interface CardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  padding?: string;
  containerColor?: string;
  bgColor?: string;
  /** When true, header and content split the card height 50/50 */
  splitVertical?: boolean;
}

const Card: React.FC<CardProps> = ({
  title,
  children,
  className,
  padding,
  containerColor,
  bgColor,
  splitVertical,
}) => {
  const layoutClass = splitVertical ? "grid grid-rows-2" : "flex flex-col";

  return (
    <div
      className={`${layoutClass} text-center font-semibold w-full ${
        containerColor ?? "bg-black"
      } rounded-md ${className ?? ""}`}
    >
      <h3
        className={`text-sm 2xl:text-lg ${
          bgColor ?? "bg-darkerBlack"
        } rounded-t-md ${padding ? padding : "p-2"} flex items-center justify-center`}
      >
        {title}
      </h3>
      <div className="flex items-center justify-center text-lg flex-1 leading-4">
        {children}
      </div>
    </div>
  );
};

export default Card;